import Klaklik from "../../assets/COver Klaklik.png";
import TMDB from "../../assets/tmdb-api.png";
import Burane from "../../assets/burane.png";
import Florist from "../../assets/florist.png";
import Dashboard from "../../assets/dashboard-creator.png";
import CreatorForum from "../../assets/creator-forum.png";
import Kursus from "../../assets/kursus.png";
import RumatKita from "../../assets/rumatkita.png";
import Rosy from "../../assets/rosy-logo.png";
import Rumatku from "../../assets/rumatku.png";
import RumatkuNative from "../../assets/rumatku-native.jpg";

// `description` : satu kalimat pendek, karena kartu ini tidak punya halaman detail.
// `url`         : hanya diisi untuk project yang boleh dibuka publik. Tanpa `url`,
//                 kartunya menampilkan ajakan menghubungi, bukan tautan demo.
// `hidden`      : project disembunyikan dari portfolio tapi datanya tetap disimpan.
//                 Hapus barisnya kalau mau ditampilkan lagi.
export const projectsData = [
  {
    id: 1,
    image: RumatKita,
    title: "Rumatkita PWA",
    description: "Patient app for Rumat home-care — registration, booking, and visit history.",
    category: "web",
    url: "https://rumatkita.com",
  },
  {
    id: 2,
    image: Rumatku,
    title: "Rumatku Absensi PWA",
    description: "Attendance PWA for Rumat's internal team, usable on desktop and mobile.",
    category: "web",
  },

  {
    id: 3,
    image: Rosy,
    title: "ROSY(Rumat Online System)",
    description: "Rumat's internal operations system: patient records, nursing notes, and billing.",
    category: "web",
  },
  {
    id: 4,
    image: Klaklik,
    title: "Klaklik",
    description: "UGC reading platform for e-novels and comics, with coin and voucher rewards.",
    category: "web",
  },
  {
    id: 5,
    image: Dashboard,
    title: "Creator Dashboard(Klaklik)",
    description: "Author console to upload works, manage episodes, and track wallet earnings.",
    category: "web",
  },
  {
    id: 6,
    image: CreatorForum,
    title: "Creator Forum(Klaklik)",
    description: "Event landing page for Klaklik Creator Forum, with speaker lineup and recaps.",
    category: "web",
  },
  {
    id: 7,
    image: Florist,
    title: "Florist Bouquet E-Commerce",
    description: "Bouquet e-commerce with product catalogue, cart, and checkout.",
    category: "web",
    hidden: true,
  },
  {
    id: 8,
    image: Burane,
    title: "Burane456 Coffee",
    description: "Company profile for a coffee and Nasi Kebuli shop, with menu and catering info.",
    category: "web",
  },
  {
    id: 9,
    image: TMDB,
    title: "Try Movie with TMDB API",
    description: "Movie discovery app built on the TMDB API.",
    category: "web",
    hidden: true,
  },
  {
    id: 10,
    image: Kursus,
    title: "Website Kursus",
    description: "Online course website with class listings and enrolment.",
    category: "web",
    hidden: true,
  },
  {
    id: 11,
    image: RumatkuNative,
    title: "Rumatku Native App",
    description: "Native mobile build of Rumatku, packaged for install on employee devices.",
    category: "app",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
